import React  from 'react';

import RAGComponentProto from './rag-proto';

export default function renderBooleanInView(id, props) {
    return <RAGComponentProto renderMode="view" id={id} {...props} />;
}